import { useLocation } from 'react-router-dom';
import { useGlobalQueries } from './use-global-queries';
import { removeTrailingSlash } from '@/utils/strings';
import { HUMANY_FAQ_QUERY_KEY, humanyFaqQuery } from '@/queries/humany';
import { useQuery, keepPreviousData } from '@tanstack/react-query';
import { useContext } from 'react';
import { AppContext } from '@/contexts/app-context';
import { humanyFaqQueryCached } from '@/queries/humany-cached';

export function useHumany({ widgetType = 'private', widgetSlug = 'kundservice' }) {
    const location = useLocation();
    const context = useContext(AppContext);
    const { getSetting } = useGlobalQueries();
    const humanySettings = getSetting('humany_settings');
    const useCached = humanySettings?.humany_use_cached ?? false;
    const pageLink = humanySettings?.humany_page_link?.replace(/\/$/g, '') ?? '';
    const pageLinkBusiness = humanySettings?.humany_page_link_business?.replace(/\/$/g, '') ?? '';
    const baseUrl = widgetType === 'private' ? pageLink : pageLinkBusiness;
    const path = removeTrailingSlash(location.pathname.replace(baseUrl, ''));

    const humanyData = useQuery({
        enabled: useCached ? true : false,
        placeholderData: keepPreviousData,
        queryKey: [HUMANY_FAQ_QUERY_KEY, widgetSlug, path || '/'],
        queryFn: () =>
            useCached ? humanyFaqQueryCached(widgetSlug, path, baseUrl, context) : humanyFaqQuery(widgetSlug, `${path}${location.search}`, baseUrl),
    });

    return {
        path,
        baseUrl,
        humanyData,
        search: location.search,
    };
}
